const query = {
  notification: () => ({
    step: 0,
  }),
};

export default query;
